import type { IErrorState } from '@/store/modules/error/types';

export const state: IErrorState = {
  error: false,
  errorArray: [],
};
